import { Button, ListIcon, MapIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import React, { FC } from 'react'

import { useToggle } from '@/hooks'

import { ListView } from './ListView/ListView'
import { MapView } from './MapView/MapView'

type Props = {
  bookablePerson: WorkspaceTab
}

export const RecommendedHomes: FC<Props> = ({ bookablePerson }) => {
  const { isShown: showMap, toggle: toggleShowMap } = useToggle()

  function renderMapToggle() {
    return showMap ? (
      <BlackButton
        className="w-22 rounded-xl bg-action-input"
        data-testid="list-view-button"
        onClick={toggleShowMap}
        renderLeftIcon={ListIcon}
        size="medium"
      >
        <p className="font-bold text-sm leading-100 text-white">List</p>
      </BlackButton>
    ) : (
      <BlackButton
        className="w-22 rounded-xl bg-action-input"
        data-testid="map-view-button"
        onClick={toggleShowMap}
        renderLeftIcon={MapIcon}
        size="medium"
      >
        <p className="font-bold text-sm leading-100 text-white">Map</p>
      </BlackButton>
    )
  }

  return (
    <RecommendedHomesWrapper className="h-full w-full" showMap={showMap}>
      <ListView bookablePerson={bookablePerson} />
      <MapView allowMapInteractions={showMap} bookablePerson={bookablePerson} />
      <AnimatedButtonWrapper>{renderMapToggle()}</AnimatedButtonWrapper>
    </RecommendedHomesWrapper>
  )
}

const BlackButton = styled(Button)`
  background-color: #000000;

  &:hover {
    background-color: #000000;
  }

  &:focus-visible {
    background-color: #000000;
  }
`

const AnimatedButtonWrapper = styled.div`
  bottom: 3rem;
  z-index: 20;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  width: 100%;
  position: absolute;
  div {
    box-shadow: 0px 0px 24px -2px rgba(0, 0, 0, 0.16);
    button:first-of-type {
      border-radius: 0 0.75rem 0.75rem 0;
    }
    button:last-child {
      border-left-width: 1px;
      border-color: rgba(206, 205, 202, 0.2);
      border-radius: 0.75rem 0 0 0.75rem;
    }
  }
`

const RecommendedHomesWrapper = styled.div<{ showMap: boolean }>`
  #search-map-wrapper {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    ${({ showMap }) => (showMap ? 'z-index: 10; opacity: 1;' : 'z-index: 0; opacity: 0; pointer-events: none;')}
  }

  #search-home-list-wrapper {
    ${({ showMap }) =>
      showMap
        ? 'z-index: 0; display: flex; height: 100%; pointer-events: none; opacity: 0;'
        : 'z-index: 10; display: flex; opacity: 1; height: 100%;'}
  }
`
